import React from 'react';
import YouTube from "react-youtube";
import Controls from "./Controls";

class DarkRoom extends React.Component {
  interval = null;
  state = {time: 0};
  opts = {
    playerVars: {
      autoplay: 1,
      controls: 0,
      disablekb: 1,
      fs: 0,
      loop: 1,
      modestbranding: 1,
      playsinline: 1,
    }
  };

  show() {
    return this.props.video.showAt && this.props.time > this.props.video.showAt;
  }

  render() {
    return <div>
      <div className="video">
        <YouTube
          videoId={this.props.id}
          opts={this.opts}
          onReady={(event) => {
            event.target.setVolume(100);
            event.target.playVideo()
          }}
          onPause={event => {
            event.target.playVideo();
            this.setState({time: 0});
            clearInterval(this.interval);
          }}
          onEnd={event => {
            event.target.playVideo();
            this.setState({time: 0});
            clearInterval(this.interval);
          }}
          onPlay={event => {
            this.interval = setInterval(() => {
              this.setState({time: parseFloat(event.target.getCurrentTime())})
            }, 100)
          }}
          onStateChange={event => {
            if (event.data === YouTube.PlayerState.CUED) {
              event.target.playVideo()
            }
          }}
        />
      </div>
      <Controls {...this.props} time={this.state.time}/>
    </div>
  }
}

export default DarkRoom;